import styled from 'styled-components';
import { red } from '../../../../styles/colors';
import { Exo } from '../../../../styles/fonts';

export const Heading = styled.h4`
    font-size: 20px;
    color: ${red};
    font-family: ${Exo};
    margin-bottom: 20px;
`;
